/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides
} from 'ethers'
import { Provider, TransactionRequest } from '@ethersproject/providers'
import type { BaseStrategy, BaseStrategyInterface } from '../BaseStrategy'

const _abi = [
  {
    inputs: [
      {
        internalType: 'address',
        name: '_controller',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: '_assetId',
        type: 'uint256'
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'lower',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'upper',
            type: 'uint256'
          }
        ],
        internalType: 'struct BaseStrategy.MinPerValueLimit',
        name: '_minPerValueLimit',
        type: 'tuple'
      },
      {
        internalType: 'string',
        name: '_name',
        type: 'string'
      },
      {
        internalType: 'string',
        name: '_symbol',
        type: 'string'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'constructor'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'owner',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'spender',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'value',
        type: 'uint256'
      }
    ],
    name: 'Approval',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address'
      }
    ],
    name: 'OwnershipTransferred',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'from',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'value',
        type: 'uint256'
      }
    ],
    name: 'Transfer',
    type: 'event'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'owner',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'spender',
        type: 'address'
      }
    ],
    name: 'allowance',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'approve',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address'
      }
    ],
    name: 'balanceOf',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'decimals',
    outputs: [
      {
        internalType: 'uint8',
        name: '',
        type: 'uint8'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'subtractedValue',
        type: 'uint256'
      }
    ],
    name: 'decreaseAllowance',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'addedValue',
        type: 'uint256'
      }
    ],
    name: 'increaseAllowance',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'name',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'symbol',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'totalSupply',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'transfer',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'transferFrom',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address'
      }
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'vaultId',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  }
]

const _bytecode =
  '0x60e06040523480156200001157600080fd5b50604051620013433803806200134383398101604081905262000034916200034a565b8181600362000044838262000495565b50600462000053828262000495565b505050620000706200006a6200018a60201b60201c565b6200018e565b6001600160a01b038516608081905260c085905283516007556020840151600855604051631d591eb760e31b8152600160048201526000919063eac8f5b89060240161050060405180830381865afa158015620000d1573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190620000f79190620007fc565b60208101516001600160a01b0390811660a081905260805160405163095ea7b360e01b815292166004830152600019602483015291925063095ea7b3906044016020604051808303816000875af115801562000157573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906200017d9190620008df565b5050505050505062000904565b3390565b600580546001600160a01b038381166001600160a01b0319831681179093556040519116919082907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a35050565b80516001600160a01b0381168114620001f857600080fd5b919050565b634e487b7160e01b600052604160045260246000fd5b604080519081016001600160401b0381118282101715620002385762000238620001fd565b60405290565b6040516101a081016001600160401b0381118282101715620002385762000238620001fd565b60405161016081016001600160401b0381118282101715620002385762000238620001fd565b604051601f8201601f191681016001600160401b0381118282101715620002b557620002b5620001fd565b604052919050565b600082601f830112620002cf57600080fd5b81516001600160401b03811115620002eb57620002eb620001fd565b602062000301601f8301601f191682016200028a565b82815285828487010111156200031657600080fd5b60005b838110156200033657858101830151828201840152820162000319565b506000928101909101919091529392505050565b600080600080600085870360c08112156200036457600080fd5b6200036f87620001e0565b9550602087015194506040603f19820112156200038b57600080fd5b506200039662000213565b604087015181526060870151602082015260808701519093506001600160401b0380821115620003c557600080fd5b620003d389838a01620002bd565b935060a0880151915080821115620003ea57600080fd5b50620003f988828901620002bd565b9150509295509295909350565b600181811c908216806200041b57607f821691505b6020821081036200043c57634e487b7160e01b600052602260045260246000fd5b50919050565b601f8211156200049057600081815260208120601f850160051c810160208610156200046b5750805b601f850160051c820191505b818110156200048c5782815560010162000477565b5050505b505050565b81516001600160401b03811115620004b157620004b1620001fd565b620004c981620004c2845462000406565b8462000442565b602080601f831160018114620005015760008415620004e85750858301515b600019600386901b1c1916600185901b1785556200048c565b600085815260208120601f198616915b82811015620005325788860151825594840194600190910190840162000511565b5085821015620005515787850151600019600388901b60f8161c191681555b5050505050600190811b01905550565b8051600281900b8114620001f857600080fd5b6000606082840312156200058757600080fd5b604051606081016001600160401b0381118282101715620005ac57620005ac620001fd565b60405282518152905080620005c46020840162000561565b6020820152620005d76040840162000561565b60408201525092915050565b6000610100808385031215620005f857600080fd5b604051908101906001600160401b03821181831017156200061d576200061d620001fd565b81604052809250835181526020840151602082015260408401516040820152606084015160608201526080840151608082015260a084015160a082015260c084015160c082015260e084015160e0820152505092915050565b6000604082840312156200068957600080fd5b6200069362000213565b9050815181526020820151602082015292915050565b60006101e08284031215620006bd57600080fd5b620006c76200023e565b9050620006d482620001e0565b8152620006e46020830162000561565b6020820152620006f76040830162000561565b6040820152606082015160608201526080820151608082015260a082015160a082015260c082015160c082015260e082015160e08201526101008083015181830152506101206200074b8482850162000676565b90820152610160620007608484830162000676565b6101408301526101a0830151908201526101c090910151610180820152919050565b80518015158114620001f857600080fd5b600060808284031215620007a657600080fd5b604051608081016001600160401b0381118282101715620007cb57620007cb620001fd565b8060405250809150825181526020830151602082015260408301516040820152606083015160608201525092915050565b600061050082840312156200081057600080fd5b6200081a62000264565b825181526200082c60208401620001e0565b60208201526200083f60408401620001e0565b604082015262000853846060850162000574565b6060820152620008678460c08501620005e3565b60808201526200087c846101c08501620006a9565b60a0820152620008906103a0840162000782565b60c0820152620008a5846103c0850162000793565b60e0820152620008ba84610440850162000793565b6101008201526104c08301516101208201526104e09092015161014083015250919050565b600060208284031215620008f257600080fd5b620008fd8262000782565b9392505050565b60805160a05160c051610a186200092b600039600050506000505060005050610a186000f3fe608060405234801561001057600080fd5b50600436106100f55760003560e01c806370a0823111610097578063a457c2d711610066578063a457c2d7146101e1578063a9059cbb146101f4578063dd62ed3e14610207578063f2fde38b1461021a57600080fd5b806370a082311461018b578063715018a6146101b45780638da5cb5b146101be57806395d89b41146101d957600080fd5b806323b872dd116100d357806323b872dd1461014d578063313ce5671461016057806333194c0a1461016f578063395093511461017857600080fd5b806306fdde03146100fa578063095ea7b31461011857806318160ddd1461013b575b600080fd5b61010261022d565b60405161010f9190610862565b60405180910390f35b61012b6101263660046108cc565b6102bf565b604051901515815260200161010f565b6002545b60405190815260200161010f565b61012b61015b3660046108f6565b6102d9565b6040516012815260200161010f565b61013f60065481565b61012b6101863660046108cc565b6102fd565b61013f610199366004610932565b6001600160a01b031660009081526020819052604090205490565b6101bc61031f565b005b6005546040516001600160a01b03909116815260200161010f565b610102610333565b61012b6101ef3660046108cc565b610342565b61012b6102023660046108cc565b6103c2565b61013f610215366004610954565b6103d0565b6101bc610228366004610932565b6103fb565b60606003805461023c90610987565b80601f016020809104026020016040519081016040528092919081815260200182805461026890610987565b80156102b55780601f1061028a576101008083540402835291602001916102b5565b820191906000526020600020905b81548152906001019060200180831161029857829003601f168201915b5050505050905090565b6000336102cd818585610474565b60019150505b92915050565b6000336102e7858285610598565b6102f2858585610612565b506001949350505050565b6000336102cd81858561031083836103d0565b61031a91906109c1565b610474565b6103276107b6565b6103316000610810565b565b60606004805461023c90610987565b6000338161035082866103d0565b9050838110156103b55760405162461bcd60e51b815260206004820152602560248201527f45524332303a2064656372656173656420616c6c6f77616e63652062656c6f77604482015264207a65726f60d81b60648201526084015b60405180910390fd5b6102f28286868403610474565b6000336102cd818585610612565b6001600160a01b03918216600090815260016020908152604080832093909416825291909152205490565b6104036107b6565b6001600160a01b0381166104685760405162461bcd60e51b815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201526564647265737360d01b60648201526084016103ac565b61047181610810565b50565b6001600160a01b0383166104d65760405162461bcd60e51b8152602060048201526024808201527f45524332303a20617070726f76652066726f6d20746865207a65726f206164646044820152637265737360e01b60648201526084016103ac565b6001600160a01b0382166105375760405162461bcd60e51b815260206004820152602260248201527f45524332303a20617070726f766520746f20746865207a65726f206164647265604482015261737360f01b60648201526084016103ac565b6001600160a01b0383811660008181526001602090815260408083209487168084529482529182902085905590518481527f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b925910160405180910390a3505050565b60006105a484846103d0565b9050600019811461060c57818110156105ff5760405162461bcd60e51b815260206004820152601d60248201527f45524332303a20696e73756666696369656e7420616c6c6f77616e636500000060448201526064016103ac565b61060c8484848403610474565b50505050565b6001600160a01b0383166106765760405162461bcd60e51b815260206004820152602560248201527f45524332303a207472616e736665722066726f6d20746865207a65726f206164604482015264647265737360d81b60648201526084016103ac565b6001600160a01b0382166106d85760405162461bcd60e51b815260206004820152602360248201527f45524332303a207472616e7366657220746f20746865207a65726f206164647260448201526265737360e81b60648201526084016103ac565b6001600160a01b038316600090815260208190526040902054818110156107505760405162461bcd60e51b815260206004820152602660248201527f45524332303a207472616e7366657220616d6f756e7420657863656564732062604482015265616c616e636560d01b60648201526084016103ac565b6001600160a01b03848116600081815260208181526040808320878703905593871680835291849020805487019055925185815290927fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef910160405180910390a361060c565b6005546001600160a01b031633146103315760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e657260448201526064016103ac565b600580546001600160a01b038381166001600160a01b0319831681179093556040519116919082907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a35050565b600060208083528351808285015260005b8181101561088f57858101830151858201604001528201610873565b506000604082860101526040601f19601f8301168501019250505092915050565b80356001600160a01b03811681146108c757600080fd5b919050565b600080604083850312156108df57600080fd5b6108e8836108b0565b946020939093013593505050565b60008060006060848603121561090b57600080fd5b610914846108b0565b9250610922602085016108b0565b9150604084013590509250925092565b60006020828403121561094457600080fd5b61094d826108b0565b9392505050565b6000806040838503121561096757600080fd5b610970836108b0565b915061097e602084016108b0565b90509250929050565b600181811c9082168061099b57607f821691505b6020821081036109bb57634e487b7160e01b600052602260045260246000fd5b50919050565b808201808211156102d357634e487b7160e01b600052601160045260246000fdfea26469706673582212201c8b4ab2dcbd063887da432f7646d57127f17a88bb163b8c1ab285fb74763a3c64736f6c63430008130033'

export class BaseStrategy__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0])
    } else {
      super(...args)
    }
  }

  deploy(
    _controller: string,
    _assetId: BigNumberish,
    _minPerValueLimit: { lower: BigNumberish; upper: BigNumberish },
    _name: string,
    _symbol: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<BaseStrategy> {
    return super.deploy(
      _controller,
      _assetId,
      _minPerValueLimit,
      _name,
      _symbol,
      overrides || {}
    ) as Promise<BaseStrategy>
  }
  getDeployTransaction(
    _controller: string,
    _assetId: BigNumberish,
    _minPerValueLimit: { lower: BigNumberish; upper: BigNumberish },
    _name: string,
    _symbol: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _controller,
      _assetId,
      _minPerValueLimit,
      _name,
      _symbol,
      overrides || {}
    )
  }
  attach(address: string): BaseStrategy {
    return super.attach(address) as BaseStrategy
  }
  connect(signer: Signer): BaseStrategy__factory {
    return super.connect(signer) as BaseStrategy__factory
  }
  static readonly bytecode = _bytecode
  static readonly abi = _abi
  static createInterface(): BaseStrategyInterface {
    return new utils.Interface(_abi) as BaseStrategyInterface
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): BaseStrategy {
    return new Contract(address, _abi, signerOrProvider) as BaseStrategy
  }
}
